import { Check, Copy } from "lucide-react";
import { useState } from "react";

interface CodeBlockProps {
	language?: string;
	children: string;
}

export function CodeBlock({ language, children }: CodeBlockProps) {
	const [copied, setCopied] = useState(false);

	const copy = async () => {
		await navigator.clipboard.writeText(children);
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	};

	return (
		<div className="my-3 rounded-lg overflow-hidden border border-border bg-[#0d1117]">
			<div className="flex items-center justify-between px-3 py-2 bg-[#161b22] border-b border-border">
				<span className="text-xs text-muted-foreground font-mono">{language || "text"}</span>
				<button
					type="button"
					onClick={copy}
					className="flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors"
				>
					{copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
					{copied ? "Copied" : "Copy"}
				</button>
			</div>
			<pre className="p-3 overflow-x-auto text-sm leading-relaxed">
				<code className="font-mono text-foreground whitespace-pre">{children}</code>
			</pre>
		</div>
	);
}
